
import React, { createRef, useEffect, useState } from 'react';

import * as Theoplayer from 'theoplayer';
import 'theoplayer/ui.css';

import ExternalConfiguration from '../../external-configuration';

const Wrapper_THEOplayer = props => {

  const container_ref = createRef();

  useEffect( () => {    // NOTE segundo parametro '[]' implica que es equivalente a componentDidMount

    const configuration = {
      libraryLocation: ExternalConfiguration.SelfHostedExternalSrcPaths.THEOplayer,
      license: ExternalConfiguration.Credentials.THEOplayerLicenseKey,
    };
    const player = new Theoplayer.Player( container_ref.current, configuration);

    player.source = {
      sources: [{
        // src: 'https://stgcdnvodvlc.codev8.net/ondemand/b4ab8f95-bc2b-4d88-8ff0-df4df19d206c/e4ba5a0a-35aa-47d2-990c-b1af1574519c_Fast_H,2500,.mp4.m3u8',
        src: ExternalConfiguration.DefaultErrorVideo,
        // type: 'application/x-mpegurl',   // NOTE hls
        // type: 'video/mp4',    // NOTE mp4
      }],
    };

    player.addEventListener( 'play', event => {
      console.log( 'play - event: ', event);
    });

    player.play();

    return () => {    // NOTE la funcion retornada se convierte en componentWillUnmount
      if( player) player.destroy();
    };
  }, []);

  // return <div id='theoplayer-container' className='theoplayer-container video-js theoplayer-skin vjs-16-9 THEOplayer' ref={container_ref} />;
  return <div id='theoplayer-container' className='theoplayer-container video-js theoplayer-skin' ref={container_ref} />;

}

export default Wrapper_THEOplayer;
